import styled from 'styled-components';

export const SectionContainer = styled.section`
  position: relative;
  display: block;
  width: 100%;
`;

export const SectionHeading = styled.h6`
  margin-bottom: 1.5em;
  color: rgb(34 34 34);
  line-height: 1.5rem;

  letter-spacing: 0;
  font-weight: 700;
  font-size: 1rem;
`;

export const SectionIndex = styled.span`
  color: rgb(34 34 34);
  margin-right: 2em;
  font-weight: 700;
`;

export const ParagraphContainer = styled.p`
  margin-bottom: 1.5em;
  line-height: 1.5rem;

  position: relative;
  letter-spacing: 0;
  color: rgb(0 0 0);

  font-size: 1rem;
  display: block;

  width: 100%;
  padding: 0;
`;

export const ParagraphIndex = styled.span`
  margin-right: 1.5em;
  color: rgb(0 0 0);
`;
